import React, { useState } from "react";
import ApplicationsDashboard from "./components/ApplicationsDashboard";
import ApplicationsPersonal from "./components/ApplicationsPersonal";
import ApplicationsEmployee from "./components/ApplicationsEmployee";
import ApplicationsPets from "./components/ApplicationsPets";
import ApplicationsAdditionalOccupants from "./components/ApplicationsAdditionalOccupants";
import ApplicationsVehicles from "./components/ApplicationsVehicles";
import ApplicationsCustomQuestions from "./components/ApplicationsCustomQuestions";
import ApplicationsPolicies from "./components/ApplicationsPolicies";
import ApplicationsPetPolicies from "./components/ApplicationsPetPolicies";
import ApplicationsLegalese from "./components/ApplicationsLegalese";
import ApplicationsRentalHistory from "./components/ApplicationsRentalHistory";

export enum AppConfigSettingsViewEnum {
  Dashboard = 'Dashboard',
  PersonalInformation = 'PersonalInformation',
  EmploymentAndIncome = 'EmploymentAndIncome',
  Pets = 'Pets',
  AdditionalOccupants = 'AdditionalOccupants',
  Vehicles = 'Vehicles',
  CustomQuestions = 'CustomQuestions',
  ApplicationsLegalese = 'ApplicationsLegalese',
  ApplicationsPolicies = 'ApplicationsPolicies',
  ApplicationsPetPolicies = 'ApplicationsPetPolicies',
  RentalHistory = 'RentalHistory',
} 

export default function ApplicationsConfigSettings() {
  const [view, setView] = useState<AppConfigSettingsViewEnum>(AppConfigSettingsViewEnum.Dashboard);

  return (
    view === AppConfigSettingsViewEnum.Dashboard ? (
      <ApplicationsDashboard setView={setView} />
    ) : view === AppConfigSettingsViewEnum.PersonalInformation ? (
      <ApplicationsPersonal setView={setView} />
    ) : view === AppConfigSettingsViewEnum.EmploymentAndIncome ? (
      <ApplicationsEmployee setView={setView} />
    ) : view === AppConfigSettingsViewEnum.Pets ? (
      <ApplicationsPets setView={setView} />
    ) : view === AppConfigSettingsViewEnum.AdditionalOccupants ? (
      <ApplicationsAdditionalOccupants setView={setView} />
    ) : view === AppConfigSettingsViewEnum.Vehicles ? (
      <ApplicationsVehicles setView={setView} />
    ) : view === AppConfigSettingsViewEnum.CustomQuestions ? (
      <ApplicationsCustomQuestions setView={setView} />  
    ) : view === AppConfigSettingsViewEnum.ApplicationsLegalese ? (
      <ApplicationsLegalese setView={setView} />  
    ) : view === AppConfigSettingsViewEnum.ApplicationsPolicies ? (
      <ApplicationsPolicies setView={setView} />  
    ) : view === AppConfigSettingsViewEnum.ApplicationsPetPolicies ? (
      <ApplicationsPetPolicies setView={setView} />  
    ) : view === AppConfigSettingsViewEnum.RentalHistory ? (
      <ApplicationsRentalHistory setView={setView} />
    ) : (
      <></>
    )
  )
}
